export const  desktopQuoteList = {
    popUpData: [
        {
            label: "Customer report",
            // icon: 'folder'
        },
        {
            label: "Internal report",
            // icon: 'edit'
        },
        {
            label: "Signature",
            // icon: 'delete'
        },
    ],
    columns: [
        {
            field: 'quoteNumber',
            headerName: 'Quote number',
        },
        {
            field: 'customerName',
            headerName: 'Customer name',
        },
        {
            field: 'coordinationDate',
            headerName: 'Coordination date',
        },
        {
            field: 'contactName',
            headerName: 'Contact name',
        },
        {
            field: 'contactPhoneNumber',
            headerName: 'Contact phone number',
        },
        {
            field: 'Actions',
            headerName: 'Actions',
        },
    ],
    rows: [
        { id: 1, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        { id: 2, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        { id: 3, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        { id: 4, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        // { id: 5, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        // { id: 6, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        // { id: 7, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        // { id: 8, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
        // { id: 9, quoteNumber: 'PE20001486', customerName: 'Dror Halperin', coordinationDate: '15/06/2023', contactName: 'A. Stasovskiy', contactPhoneNumber: '050 000 00 00' },
    ],
}